module.exports = __webpack_public_path__ + "img/amenities-01.ae135120.jpg";